<template>
	<div class="layout">
		<el-dialog title="登录" :visible.sync="centerDialogVisible2" width="400px" center>
			<el-form class="elForm demo-ruleForm" :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm"
				label-width="100px">
				<el-form-item label="用户账号:" prop="username">
					<el-input prefix-icon="el-icon-user-solid" v-model="ruleForm2.username" autocomplete="true"
						placeholder="请输入账号"></el-input>
				</el-form-item>
				<el-form-item label="用户密码:" prop="password">
					<el-input prefix-icon="el-icon-lock" type="password" placeholder="请输入密码"
						v-model="ruleForm2.password" show-password autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<span class="login_title">
				如果忘记密码请联系管理员重置密码
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button class="buttn_primary" type="primary" @click="submitLogin('ruleForm')">登 录</el-button>
				<el-button @click="centerDialogVisible2 = false">取 消</el-button>
			</span>
		</el-dialog>
		<div class="top_bar">
			<div class="top_bar_wrap">
				<div class="left">
					<div class="logo">
						<img src="../../assets/xiangning/layout/school_logo3.png" alt="">
					</div>
				</div>
				<div class="right">

					<div class="management">
						<div class="userName">
							<div class="school_pic" v-if="username || u_name">
								<img src="../../assets/xiangning/layout/school_pic.png" alt="">
							</div>
							<span v-if="dw" @click="goUserCenter">{{ dw }}</span>
							<!-- <span v-else-if="u_name" @click="goUserCenter">{{ u_name }}</span> -->
						</div>
						<span class="login_button"><a style="text-decoration: none; color: #fff;"
								href="http://dj.gxsentu.net/dj3.5admin/" target="_blank">管理后台</a></span>&nbsp;&nbsp;
						<span class="login_button" @click="centerDialogVisible2 = true" v-if="!userid">登录</span>
						<span class="login_button" v-else @click="userQuit">退出登录</span>
						&nbsp;&nbsp;
						<span class="login_button mobileTerminal">移动端
							<div class="mobileTerminalCode">
								<img src="../../assets/mobileTerminalCode.jpg" alt="">
							</div>
						</span>
						&nbsp;&nbsp;

					</div>
				</div>

			</div>

		</div>
		<!-- 导航 -->
		<div class="nav">
			<div class="nav_wrap" @click="goPage">
				<div style="height: 100%;display: flex;">
					<!-- <router-link :to="{ path: '/?index=1' }" class="nav_item" :class="{ selectNav: selectNav == 1 }">
						<div v-if="selectNav == 1" class="selece_icon">
							<img src="../../assets/xiangning/layout/layout_select.png" alt="">
						</div>
						首页
					</router-link> -->
					<div @click.stop="">
						<router-link :to="{ path: '/?index=1&nav=1' }" class="nav_item"
							:class="{ selectNav: selectNav == 1 }">
							<div v-if="selectNav == 1" class="selece_icon">
								<img src="../../assets/xiangning/layout/layout_select.png" alt="">
							</div>
							首页
						</router-link>
					</div>
					<router-link :to="$store.state.user.userinfo2.id ? { path: '/djxx?index=2&nav=1' } : ''"
						class="nav_item" :class="{ selectNav: selectNav == 2 }">党建学习
						<div v-if="selectNav == 2" class="selece_icon">
							<img src="../../assets/xiangning/layout/layout_select.png" alt="">
						</div>
					</router-link>
					<router-link :to="$store.state.user.userinfo2.id ? { path: '/ztpx?index=3&nav=1' } : ''"
						class="nav_item" :class="{ selectNav: selectNav == 3 }">专题培训
						<div v-if="selectNav == 3" class="selece_icon">
							<img src="../../assets/xiangning/layout/layout_select.png" alt="">
						</div>
					</router-link>
					<router-link :to="$store.state.user.userinfo2.id ? { path: '/tssz?index=4&nav=1' } : ''"
						class="nav_item" :class="{ selectNav: selectNav == 4 }">图说时政
						<div v-if="selectNav == 4" class="selece_icon">
							<img src="../../assets/xiangning/layout/layout_select.png" alt="">
						</div>
					</router-link>
					<router-link :to="$store.state.user.userinfo2.id ? { path: '/tjdj?index=5&nav=1' } : ''"
						class="nav_item" :class="{ selectNav: selectNav == 5 }">图解党建
						<div v-if="selectNav == 5" class="selece_icon">
							<img src="../../assets/xiangning/layout/layout_select.png" alt="">
						</div>
					</router-link>
					<router-link :to="$store.state.user.userinfo2.id ? { path: '/djbk?index=6&nav=1' } : ''"
						class="nav_item" :class="{ selectNav: selectNav == 6 }">党建百科
						<div v-if="selectNav == 6" class="selece_icon">
							<img src="../../assets/xiangning/layout/layout_select.png" alt="">
						</div>
					</router-link>
					<router-link :to="$store.state.user.userinfo2.id ? { path: '/zcjd?index=7&type=zcjd&nav=1' } : ''"
						class="nav_item" :class="{ selectNav: selectNav == 7 }">政策解读
						<div v-if="selectNav == 7" class="selece_icon">
							<img src="../../assets/xiangning/layout/layout_select.png" alt="">
						</div>
					</router-link>
					<router-link :to="$store.state.user.userinfo2.id ? { path: '/hsyzt?index=8&nav=1' } : ''"
						class="nav_item" :class="{ selectNav: selectNav == 8 }">红色云展厅
						<div v-if="selectNav == 8" class="selece_icon">
							<img src="../../assets/xiangning/layout/layout_select.png" alt="">
						</div>
					</router-link>
					<router-link :to="$store.state.user.userinfo2.id ? { path: '/yxzl?index=9&nav=1' } : ''"
						class="nav_item" :class="{ selectNav: selectNav == 9 }">院校专栏
						<div v-if="selectNav == 9" class="selece_icon">
							<img src="../../assets/xiangning/layout/layout_select.png" alt="">
						</div>
					</router-link>
				</div>
				<div class="layout_search" v-if="$route.path!='/search'">
					<input class="right_input" v-model="inputValue" type="text" placeholder="输入要查询的关键词">
					<button class="search_button" @click="goSearch">搜索</button>
				</div>
			</div>

		</div>
		<!-- 显示区域 -->
		<div class="showCenter" style="min-height: 700px;">

			<!-- <keep-alive>
				<router-view v-if="keepAlive" :key="key" @highLight="changeNav" @applyShow="applyShow" />
			</keep-alive>
			<router-view v-if="!keepAlive" @highLight="changeNav" @applyShow="applyShow"></router-view> -->
			<keep-alive >
				<router-view v-if="$route.meta.keepAlive" @highLight="changeNav"></router-view>
			</keep-alive>
			<router-view v-if="!$route.meta.keepAlive" @highLight="changeNav" ></router-view>

		</div>
		<div class="footer">

			<div class="footer_wrap">
				<div class="logo">
					<img src="../../assets/xiangning/layout/footer_logo1.png">
				</div>
				<div class="right">
					<!-- <div></div> -->
					<div>服务邮箱：sentu@jiuye.com</div>
					<div>电话： 4009019665</div>
					<div style="margin-right: 0;">地址：北京市海淀区知春路甲48号盈都大厦A座12层15B</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { user } from '@/axios'

import { Message } from 'element-ui'
export default {
	data() {
		return {
			dw: this.$store.state.user.userinfo2.dw,
			userid: this.$store.state.user.userinfo2.id,
			username: this.$store.state.user.userinfo2.username,
			u_name: this.$store.state.user.userinfo2.u_name,
			flag: this.$store.state.user.userinfo2.flag,
			selectNav: 1,
			applyLogin: false,
			hidden: 0,
			hidden2: 0,
			inputValue: '',
			centerDialogVisible2: false,
			// 登录
			ruleForm2: {
				username: '',
				password: '',
			},
			rules2: {
				username: [
					{ required: true, message: '请输入账号', trigger: 'blur' },
				],
				password: [
					{ required: true, message: '密码不能为空', trigger: 'blur' },
					{ min: 6, max: 20, message: '密码长度在6到 20 个字符', trigger: 'blur' }
				],
			},
			keepAlive: false,
			include: []
		}
	},
	computed: {
		key() {
			return this.$route.path
		}

	},
	watch: {
        $route(to, from) {
          //如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
          if (to.meta.keepAlive) {
            !this.include.includes(to.name) && this.include.push(to.name);
          }
		  //如果 要 form(离开) 的页面是 keepAlive缓存的，
          //再根据 deepth 来判断是前进还是后退
          //如果是后退
          if ( to.meta.deepth == from.meta.deepth) {
            var index = this.include.indexOf(to.name);
            index !== -1 && this.include.splice(index, 1);
          }else if(to.meta.deepth>from.meta.deepth){
			!this.include.includes(from.name) && this.include.push(from.name);
		  }
		  console.log(this.include);
		  console.log(this.$route.meta.keepAlive);

        }
      },
	// watch: {
	// 	$route(to, from) {
	// 		if (to.meta.keepAlive) {
	// 			this.keepAlive = true
	// 			if (from.meta.deepth == 0.5) {
	// 				this.keepAlive = false
	// 			}
			
	// 		}else{
	// 			this.keepAlive=false
	// 		}
	// 	}
	// },
	methods: {
		goPage() {

			if (!this.userid) {
				Message({
					type: "error",
					message: "请先登录"
				})
			}
		},
		// 当鼠标移入时控制hidden的值控制显示与隐藏
		changeHidden(index) {
			this.hidden = index
		},
		changeHidden2(index) {
			this.hidden2 = index
		},
		// 接收子元素传来高亮导航 并跳转详情页
		changeNav(index, bsid, id, type) {
			console.log('dsadsa',index);
			document.getElementsByClassName("layout").scrollTop = 0;
			var that = this;
			that.selectNav = index;
			if (bsid != "" && id != "") {
				that.$szzy.goDetail(bsid, id, index, type)
			}
		},
		// 申请入驻窗口打开
		applyShow() {
			var that = this;
			that.applyLogin = true;
		},
		// 申请入驻窗口关闭
		closeWin() {
			var that = this;
			that.applyLogin = false;
		},
		// 学校列表入口
		login() {
			var that = this;
			that.$router.push('/gxyxList')
		},
		// 点击搜索按钮跳转至搜索详情页
		goSearch() {
			let that = this
			if (!this.userid) {
				Message({
					type: "error",
					message: "请先登录"
				})

			} else if (that.inputValue.trim() != '') {
				this.$router.push({
					path: '/search',
					query: {
						keys: that.inputValue,
					}
				})

				//  清空input框
				this.inputValue = ''
			} else {
				Message({
					type: "error",
					message: "搜索内容不能为空"
				})
			}


		},
		// 跳转至个人中心
		goUserCenter() {
			this.$router.push({
				path: "/userCenter",
			})


		},
		// 登录
		submitLogin(formName) {
			let that = this
			// 选择人员
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 向服务器发起请求登录
					user.loginUsers(that.ruleForm2).then((res) => {
						if (res.code == 200) {

							Message({
								type: "success",
								message: "登录成功"
							})
							this.$store.commit('setUserInfo', res.data)
							this.centerDialogVisible2 = false
							this.$router.go(0)

						}
					})

				} else {

					return false;
				}
			});
		},
		// 用户退出
		userQuit() {
			this.$store.commit('clearUserInfo', '')
		}
	},
	mounted() {
		console.log(this.$route.meta.keepAlive);
	}
}
</script>

<style lang="scss">
@import '@/common/index.scss';

.layout {
	width: 100%;
	height: 100%;

	.top_bar {
		height: 100px;
		width: 100%;
		background: #fff;

		&_wrap {
			width: $indexWidth;
			height: 100%;
			margin: auto;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.left {
				display: flex;

				.logo {
					height: 46px;
					margin-right: 17px;

					img {
						height: 100%;
						width: auto;
					}
				}

				.logo2 {
					padding-top: 11px;
					height: 50px;
					width: 289px;

					img {
						height: 100%;
						width: auto;
					}
				}
			}

			.right {
				position: relative;
				display: flex;


				.management {
					padding-top: 10px;
					display: flex;
					font-family: 思源黑体;
					font-size: 14px;
					font-weight: normal;
					color: #EE632B;
					margin-left: 15px;

					.userName {
						height: 32px;
						display: flex;
						align-items: center;
						margin-right: 10px;

						.school_pic {
							width: 32px;
							height: 32px;
							border-radius: 50%;
							overflow: hidden;
							margin-right: 5px;

							img {
								width: 100%;
								height: 100%;
							}
						}

						span {
							font-family: PingFangSC-Semibold;
							font-size: 16px;
							font-weight: normal;
							line-height: normal;
							letter-spacing: 0px;
							color: #C81C1D;
						}
					}

					.login_button {
						display: block;
						width: 80px;
						height: 32px;
						border-radius: 16px;
						background-color: #C81C1D;
						line-height: 32px;
						text-align: center;
						color: #FFFFFF;
					}

					a {
						text-decoration: none;
						color: #EE632B;
					}

					span {
						cursor: pointer;
					}
				}

				.login_bottim {
					background-color: #EE632B;
					width: 72px;
					height: 32px;
					border-radius: 16px;
					border: 1px solid #EE632B;
					color: #fff;
					font-family: 思源黑体;
					font-size: 14px;
					font-weight: normal;
					line-height: 17px;
				}
			}
		}


	}

	// 导航
	.nav {
		width: 100%;
		height: 48px;
		line-height: 48px;
		background: #C81C1D;
		font-size: 14px;
		position: relative;

		&_wrap {
			position: relative;
			margin: auto;
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 100%;
			font-size: $indexSize;
			width: $indexWidth;
			font-size: 14px;
			justify-content: space-between;

			.nav_item {
				display: block;
				cursor: pointer;
				padding: 0 27px;
				text-align: center;
				color: #fff;
				text-decoration: none;
				position: relative;

				.selece_icon {
					position: absolute;
					left: 50%;
					top: 0;
					transform: translateX(-50%);
					width: 40px;
					height: 48px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				&:hover {
					background: linear-gradient(180deg, rgba(250, 4, 4, 0.08) 0%, #C81C1D 100%);
				}
			}

			#nav_item2 {
				position: relative;

				img {
					position: absolute;
					left: 115px;
					top: 20px;
					transition: all 0.6s;
				}
			}

			#nav_item2:hover {
				img {
					transform: rotate(-90deg);
				}
			}

			.hidden {
				position: absolute;
				top: 48px;
				left: 176px;
				z-index: 999;
				background-color: #EE632B;
			}

			.hidden2 {
				position: absolute;
				top: 48px;
				left: 353px;
				z-index: 999;
				background-color: #EE632B;
			}

			// .nav_item:hover{
			// 	font-family: 'syht';
			// }


		}

		.layout_search {
			position: relative;

			input {
				display: block;
				height: 36px;
				width: 200px;
				border-radius: 20px;
				border: 1px solid #FFFFFF;
				padding-left: 20px;
				outline: none;
				color: #fff;
				background-color: #C81C1D;

			}

			input::-webkit-input-placeholder {
				// 针对 谷歌 内核
				color: #DE7777;
				line-height: 40px;
				font-size: 14px;
			}

			.search_button {
				position: absolute;
				right: 4px;
				top: 3px;
				background-color: #fff;
				width: 72px;
				height: 32px;
				border-radius: 16px;
				border: 1px solid #fff;
				color: #C81C1D;
				font-family: 思源黑体;
				font-size: 14px;
				font-weight: normal;
				line-height: 17px;
			}

		}
	}

	.footer {
		width: 100%;
		height: 167px;
		color: #fff;
		background: #C81C1D;
		overflow: hidden;

		.footer_wrap_top {
			height: 100%;
			height: 20px;
			margin-top: 10px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		&_wrap {
			width: $indexWidth;
			margin: auto;
			display: flex;
			flex-direction: column;
			// height: 100%;
			height: 80%;
			align-items: center;
			position: relative;
			justify-content: center;

			.logo {
				height: 46px;
				margin-bottom: 26px;

				img {
					height: 100%;
					width: auto;
				}
			}

			.right {
				height: 18px;
				font-family: MicrosoftYaHei;
				font-size: 14px;
				font-weight: normal;
				color: #FFFFFF;
				display: flex;

				div {
					margin-right: 10px;
				}

			}

			.friendLink {
				position: absolute;
				top: 160px;
				left: 0;
				height: 25px; 
				width: 100%;
				font-family: 思源黑体;
				font-size: 14px;
				font-weight: 400;
				line-height: 25px;
				text-align: justify;
				/* 浏览器可能不支持 */
				letter-spacing: 0.21em;
				color: #FFFFFF;

				a {
					// text-decoration: none;
					color: #FFFFFF;
				}

			}

		}

	}

	.showCenter {
		width: 100%;
		font-size: 0;
		margin: auto;
		min-height: 400px;
	}
}

.selectNav {
	// background: linear-gradient(180deg, rgba(214, 137, 12, 0.08) 0%, #a00c0c 100%);
	// font-family: PingFangSC-Semibold;
	// // font-size: 18px;
	// font-weight: normal;
}

.mobileTerminal {
	position: relative;

	.mobileTerminalCode {
		position: absolute;
		bottom: -180x;
		left: -70px;
		width: 150px;
		height: 166px;
		border-radius: 8px;
		overflow: hidden;
		display: none;
		background-color: pink;
		z-index: 1000;

		img {
			width: 100%;
			width: 100%;
		}
	}
}

.mobileTerminal:hover {
	.mobileTerminalCode {
		display: block;
	}
}
</style>
